import React from "react";
import { useNavigate } from "react-router-dom";
import { buildCatalogPath, getCatalogVendeur, isCatalogPath } from "../../../catalog/catalogTenant";
import CatalogFooterCredit from "../../../catalog/CatalogFooterCredit";
import { FaCartShopping } from "react-icons/fa6";
import { useAppSelector } from "../../../redux/hook";
import { getImage } from "../../../utils/Utils";
import SearchForm from "../FrontHeader/SearchForm";
import defaultAvatar from "../../../assets/images_td/appImages/Avatar.png";

interface TemplateNavbarProps {
  vendeurName?: string;
  showSearch?: boolean;
}

export default function TemplateNavbar({
  vendeurName,
  showSearch = true,
}: TemplateNavbarProps) {
  const navigate = useNavigate();
  const { cartItems } = useAppSelector((s) => s.cart);
  const cartCount = cartItems?.length ?? 0;
  const catalogVendeur = getCatalogVendeur();
  const isCatalog = isCatalogPath();

  const storeName =
    vendeurName ||
    catalogVendeur?.nom_boutique ||
    catalogVendeur?.nom_de_la_boutique ||
    "Nom de la boutique";

  const avatarSrc = catalogVendeur?.avatar
    ? getImage(catalogVendeur.avatar)
    : defaultAvatar;

  return (
    <nav className="template-navbar">
      <button
        type="button"
        className="template-navbar__cart-btn"
        title="Panier"
        onClick={() => navigate(buildCatalogPath("/valider-commande"))}
      >
        <div className="template-navbar__cart-icon-wrapper">
          <FaCartShopping size={26} color="white" />
          {cartCount > 0 && (
            <span className="template-navbar__cart-badge">{cartCount}</span>
          )}
        </div>
      </button>

      <div
        className="template-navbar__logo"
        onClick={() => navigate(buildCatalogPath("/"))}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            navigate(buildCatalogPath("/"));
          }
        }}
        role="button"
        tabIndex={0}
        title="Accueil"
      >
        <img
          src={avatarSrc}
          alt={storeName}
          className="template-navbar__logo-img"
        />
      </div>

      <div className="template-navbar__store-name">{storeName}</div>

      {showSearch && (
        <SearchForm useTemplateStyle={true} placeholder="Recherchez ici" />
      )}

      {isCatalog ? <CatalogFooterCredit /> : null}
    </nav>
  );
}
